import { DailyForecastData } from '@store';

import { NUM_DAYS } from './constants';
import { DayForecast } from './types';

const isPopulatedArray = (value: unknown[] | undefined) => Array.isArray(value) && value.length > 0;

export const getDayForecasts = (data: DailyForecastData, isLoading: boolean, error: unknown): DayForecast[] => {
  if (isLoading) {
    return Array.from({ length: NUM_DAYS }).fill({ isLoading: true }) as DayForecast[];
  } else if (error || !data) {
    return Array.from({ length: NUM_DAYS }).fill({ error }) as DayForecast[];
  }

  const dayForecasts = [];

  for (let index = 0; index < NUM_DAYS; index++) {
    const daypart = isPopulatedArray(data?.daypart) ? data.daypart[0] : undefined;
    const daypartIndex = index * 2;
    // If we have turned over past 3PM, the today values are null so use next index (tonight) values
    const adjustedDaypartIndex =
      isPopulatedArray(daypart?.daypartName) && daypart?.daypartName[daypartIndex] ? daypartIndex : daypartIndex + 1;
    const validTimeUtc = isPopulatedArray(data?.validTimeUtc) ? data.validTimeUtc[index] : undefined;
    const daypartName = isPopulatedArray(daypart?.daypartName) ? daypart?.daypartName[adjustedDaypartIndex] : undefined;
    const iconCodeExtend = isPopulatedArray(daypart?.iconCodeExtend)
      ? daypart?.iconCodeExtend[adjustedDaypartIndex]
      : undefined;
    const wxPhraseLong = isPopulatedArray(daypart?.wxPhraseLong)
      ? daypart?.wxPhraseLong[adjustedDaypartIndex]
      : undefined;
    const dayTemporary = isPopulatedArray(daypart?.temperature) ? daypart?.temperature[daypartIndex] : undefined;
    const nightTemporary = isPopulatedArray(daypart?.temperature) ? daypart?.temperature[daypartIndex + 1] : undefined;
    const precipChance = isPopulatedArray(daypart?.precipChance)
      ? daypart?.precipChance[adjustedDaypartIndex]
      : undefined;

    dayForecasts.push({
      dayIndex: index,
      // Only used for today/tonight/tomorrow (first two days have names.) Otherwise, use UTC time for day of week.
      dayName: daypartName,
      validTimeUtc,
      iconCodeExtend,
      wxPhraseLong,
      dayTemp: dayTemporary,
      nightTemp: nightTemporary,
      precipChance,
    });
  }
  return dayForecasts;
};
